/* IslamifyBox theme JS — sticky header state + subtle reveal on scroll. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('[data-header]');

    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var revealEls = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else if (revealEls.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealEls.forEach(function (el) { io.observe(el); });
    }

    /* Sticky mobile buy bar: show once the hero scrolls out of view. */
    var hero = document.querySelector('[data-hero]');
    var bar = document.querySelector('[data-sticky-buy]');
    if (hero && bar && 'IntersectionObserver' in window) {
      var toggleBar = function () {
        var rect = hero.getBoundingClientRect();
        bar.classList.toggle('is-visible', rect.bottom < 0);
      };
      new IntersectionObserver(toggleBar, { threshold: 0 }).observe(hero);
      window.addEventListener('scroll', toggleBar, { passive: true });
      toggleBar();
    }

    /* Hero gallery: thumbnails + touch swipe. Locked 1:1 stage, so images
       can never stretch — object-fit handles every aspect ratio. */
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      var stage = gallery.querySelector('[data-gallery-stage]');
      if (!main || !thumbs.length) return;
      var index = 0;

      function show(i) {
        index = (i + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        var src = thumb.getAttribute('data-gallery-thumb');
        if (!src || main.getAttribute('src') === src) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.setAttribute('src', src);
          var srcset = thumb.getAttribute('data-gallery-thumb-srcset');
          if (srcset) { main.setAttribute('srcset', srcset); }
          else { main.removeAttribute('srcset'); }
          main.setAttribute('alt', thumb.getAttribute('aria-label') || main.getAttribute('alt'));
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          main.style.opacity = '1';
        }, 140);
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });

      if (stage) {
        var startX = null;
        stage.addEventListener('touchstart', function (e) {
          if (e.touches.length === 1) startX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    });

    /* Quantity steppers: every buy form on the page stays in sync. */
    function setAllQuantities(n) {
      n = Math.max(1, Math.min(10, n || 1));
      document.querySelectorAll('[data-qty-input]').forEach(function (input) {
        input.value = String(n);
      });
    }

    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var dec = stepper.querySelector('[data-qty-dec]');
      var inc = stepper.querySelector('[data-qty-inc]');
      if (dec) dec.addEventListener('click', function () {
        setAllQuantities((parseInt(input.value, 10) || 1) - 1);
      });
      if (inc) inc.addEventListener('click', function () {
        setAllQuantities((parseInt(input.value, 10) || 1) + 1);
      });
    });

    /* Countdown timer: rolls to local midnight, updates every second. */
    var cd = document.querySelector('[data-countdown]');
    if (cd) {
      var cdh = cd.querySelector('[data-cd-h]');
      var cdm = cd.querySelector('[data-cd-m]');
      var cds = cd.querySelector('[data-cd-s]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var now = new Date();
        var end = new Date(now);
        end.setHours(23, 59, 59, 999);
        var diff = Math.max(0, end - now);
        var total = Math.floor(diff / 1000);
        if (cdh) cdh.textContent = pad(Math.floor(total / 3600));
        if (cdm) cdm.textContent = pad(Math.floor((total % 3600) / 60));
        if (cds) cds.textContent = pad(total % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  });
})();

/* Upsell modal: intercept buy forms, offer the $10 custom-disc add-on. */
(function () {
  'use strict';

  var UPSELL_HANDLE = 'custom-disc-photos';

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.querySelector('[data-upsell-overlay]');
    if (!overlay) return;

    var singleBox = overlay.querySelector('[data-upsell-single]');
    var multiBox = overlay.querySelector('[data-upsell-multi]');
    var yesBtn = overlay.querySelector('[data-upsell-yes]');
    var yesMultiBtn = overlay.querySelector('[data-upsell-yes-multi]');
    var noBtns = overlay.querySelectorAll('[data-upsell-no]');
    var nEl = overlay.querySelector('[data-upsell-n]');
    var boxCountEls = overlay.querySelectorAll('[data-upsell-boxcount], [data-upsell-boxcount2]');
    var multiDec = overlay.querySelector('[data-upsell-dec]');
    var multiInc = overlay.querySelector('[data-upsell-inc]');

    var pendingForm = null;
    var boxQty = 1;
    var customCount = 1;
    var upsellReady = false;

    /* Check once whether the upsell product exists. */
    fetch('/products/' + UPSELL_HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.variants && p.variants.length) upsellReady = true;
      })
      .catch(function () { /* upsell unavailable — forms submit normally */ });

    function formQuantity(form) {
      var q = form ? form.querySelector('[data-qty-input]') : null;
      var n = parseInt(q && q.value, 10);
      return Math.max(1, Math.min(10, n || 1));
    }

    function updateMulti() {
      if (nEl) nEl.textContent = String(customCount);
      boxCountEls.forEach(function (el) { el.textContent = String(boxQty); });
      if (yesMultiBtn) yesMultiBtn.textContent = 'Continue — +$' + (customCount * 10);
      if (multiDec) multiDec.disabled = customCount <= 1;
      if (multiInc) multiInc.disabled = customCount >= boxQty;
    }

    function openModal(form) {
      pendingForm = form;
      boxQty = formQuantity(form);
      customCount = 1;
      if (boxQty > 1 && multiBox) {
        if (singleBox) singleBox.hidden = true;
        multiBox.hidden = false;
        updateMulti();
      } else {
        if (singleBox) singleBox.hidden = false;
        if (multiBox) multiBox.hidden = true;
      }
      overlay.hidden = false;
      document.body.classList.add('upsell-open');
    }

    function closeModal() {
      overlay.hidden = true;
      document.body.classList.remove('upsell-open');
      pendingForm = null;
      if (yesBtn) {
        yesBtn.disabled = false;
        yesBtn.textContent = 'Yes, add my photos — $10';
      }
    }

    function clearCart() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('clear failed');
        return r.json();
      }).catch(function () { /* non-fatal: proceed with add anyway */ });
    }

    function postAdd(data) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      });
    }

    /* Every Buy Now starts from an empty cart, so the shopper can never
       end up paying for duplicated items by going back and clicking again. */
    function submitPlayerOnly() {
      var form = pendingForm;
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var playerVariantId = idInput ? idInput.value : null;
      var qty = formQuantity(form);
      closeModal();
      if (!playerVariantId) { if (form) form.submit(); return; }
      clearCart()
        .then(function () { return postAdd({ id: playerVariantId, quantity: qty }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { if (form) form.submit(); });
    }

    function studioUrl(boxes, custom) {
      var dest = '/pages/custom-disc-photos?boxes=' + boxes + '&custom=' + custom;
      var pm = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
      if (pm) dest += '&preview_theme_id=' + pm[1];
      return dest;
    }

    function goToStudio() {
      closeModal();
      /* "Yes" goes to the photo studio page: the shopper uploads and
         positions photos (or picks our default designs) per box, then the
         page adds player + add-on(s) and heads to checkout. */
      window.location.href = studioUrl(boxQty, boxQty > 1 ? customCount : 1);
    }

    if (yesBtn) yesBtn.addEventListener('click', goToStudio);
    if (yesMultiBtn) yesMultiBtn.addEventListener('click', goToStudio);

    if (multiDec) multiDec.addEventListener('click', function () {
      customCount = Math.max(1, customCount - 1);
      updateMulti();
    });
    if (multiInc) multiInc.addEventListener('click', function () {
      customCount = Math.min(boxQty, customCount + 1);
      updateMulti();
    });

    noBtns.forEach(function (btn) {
      btn.addEventListener('click', submitPlayerOnly);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) submitPlayerOnly();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) submitPlayerOnly();
    });

    document.querySelectorAll('.buy-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.disabled) return; /* unavailable variant */
        if (!upsellReady) return; /* no upsell product — normal submit */
        e.preventDefault();
        openModal(form);
      });
    });
  });
})();
